import { Component, EventEmitter, OnInit, OnDestroy, Output, Input } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { MapHelperService } from 'src/services/map-helper.service';
import { LayerService } from '../../../../map-features/sections/locations-section/services/Layers.service';
import { InfoBoxMapService } from 'src/services/maps/features/InfoBox-Map.service';
import { LocationsMapService } from 'src/app/features/map-features/sections/locations-section/services/LocationsMap.service';
import { RouteFilterService } from '../../../../map-features/sections/route-section/services/Route-Filter.service';
import { Subscription } from 'rxjs';
import { ToolsEnum } from '../../utils/enums/toolsEnum';
import { AllowedDTO } from '../../utils/models/allowedDTO';
import { MapRestrictionsService } from '../../services/MapRestrictions.service';

@Component({
  selector: 'map-tools',
  templateUrl: './map-tools.component.html',
  styleUrls: ['./map-tools.component.css'],
  animations: [
    trigger('mostrarCapas', [
      state('visible', style({ opacity: 1, width: '*' })),
      state('hidden', style({ opacity: 0, width: '0px', overflow: 'hidden', display: 'none' })),
      transition('visible <=> hidden', animate('300ms ease-in-out')),
    ]),
    trigger('mostrarGeocodificador', [
      state('visible', style({ opacity: 1, width: '*' })),
      state('hidden', style({ opacity: 0, width: '0px', overflow: 'hidden', display: 'none' })),
      transition('visible <=> hidden', animate('300ms ease-in-out')),
    ]),
  ]
})
export class MapToolsComponent implements OnInit, OnDestroy {

  ToolsEnum = ToolsEnum;
  allowedParts: AllowedDTO;

  // Variables de botones de herramientas
  isMapPlacesActive: boolean = false;
  isLayersPanelActive: boolean = false;
  isGeocoderActive: boolean = false;

  // Coordenadas del centro del mapa (valores por defecto)
  private _CENTER_LAT = "24.226252";
  private _CENTER_LNG = "-103.0266765";
  private _CENTER_ZOOM = "4.5";

  // Variables para panel de streetView
  showStreetViewBox = false;
  streetViewBoxTitle = 'Cargando...';
  descriptionCords = { y: 0, x: 0 };
  streetViewBoxDescription = '';

  private infoBoxSubscription: Subscription | null = null;
  private infoBoxDeactivatedSubscription: Subscription | null = null;

  @Output() centerMapEvent = new EventEmitter<void>();

  constructor(
    private mapHelperService: MapHelperService,
    public layerService: LayerService,
    public infoBoxMapService: InfoBoxMapService,
    private locationsMapService: LocationsMapService,
    private routeFilterService: RouteFilterService,
    private mapRestrictionsService: MapRestrictionsService
  ) {}

  ngOnInit(): void {
    this.allowedParts = this.mapRestrictionsService.allowedParts$.value;
    this.infoBoxMapService.infoBoxClick.next(null);
    this.infoBoxSubscription = this.infoBoxMapService.infoBoxClick$.subscribe(location => {
      if (location) {
        this.streetViewBoxDescription = `${location.lat.toFixed(5)}, ${location.lng.toFixed(5)}`;
        this.descriptionCords = { y: location.lat, x: location.lng };
        this.showStreetViewBox = true;
        this.streetViewBoxTitle = 'Cargando...';
        this.routeFilterService.GetDirection(this.descriptionCords.y, this.descriptionCords.x).subscribe(direction => {
          this.streetViewBoxTitle = direction;
        });
      }
    });
    this.infoBoxDeactivatedSubscription = this.infoBoxMapService.infoBoxDeactivated.subscribe(() => {
      this.closeInfoBox();
    });
  }

  ngOnDestroy(): void {
    if (this.infoBoxSubscription) {
      this.infoBoxSubscription.unsubscribe();
    }
    if (this.infoBoxDeactivatedSubscription) {
      this.infoBoxDeactivatedSubscription.unsubscribe();
    }
  }

  openGeocoder() {
    // if (this.mapHelperService.geocoder) {
    //   this.mapIntentService.RemoveMapboxPlaces();
    //   this.isMapPlacesActive = false;
    // } else {
    //   this.mapIntentService.AddMapboxPlaces();
    //   this.isMapPlacesActive = true;
    // }
    this.isGeocoderActive = !this.isGeocoderActive;
  }

  toggleLayersPanel() {
    this.isLayersPanelActive = !this.isLayersPanelActive;
  }

  centerMap() {
    this.mapHelperService.fitBoundsToMexico();
    this.centerMapEvent.emit();
  }

  closeInfoBox() {
    this.streetViewBoxDescription = '';
    this.descriptionCords = { y: 0, x: 0 };
    this.showStreetViewBox = false;
    if (this.infoBoxMapService.mapClickMarker) {
      this.infoBoxMapService.mapClickMarker.remove();
    }
  }

  openStreetView() {
    this.locationsMapService.loadStreetView(this.descriptionCords.x.toFixed(5), this.descriptionCords.y.toFixed(5));
  }
}
